var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FilePodcastContainer, GridTable, GridTableDragList, HeaderItem, InputPodcastContainer, LinkTimeCodeInputWrapper, PodcastAddButton, PodcastEditBlockWrapper, PodcastContentWrapper, PodcastTitle, PodcastRightColumn, TableWrapper, WhiteFieldItem, IframeLinkInputWrapper, IframeLinkInputContainer, IframeLinkInput, IframeLinkError, PreviewAudioWrapper } from './styles';
import useLocalization from '../../../../../hooks/useLocalization';
import PlusIcon from '../../../../icons/PlusIcon';
import { DownloadIcon } from './components/DownloadIcon';
import CloseIcon from '../../../../icons/CloseIcon';
import { FlexBox } from '@brg/ui';
import { DragTableIcon } from './icons/DragTableIcon';
import { DeleteTableIcon } from './icons/DeleteTableIcon';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { TimeCodeTimeInput } from './components/TimeCodeTimeInput';
import { CopyLinkSwitcher } from './components/CopyLinkSwitcher';
import checkVideoType from '../../../../../utilites/checkVideoType';
import AudioPost from '../../postblocks/audioblock';
var getTimeNumber = function (value) {
    var values = value.split(':');
    if ((values === null || values === void 0 ? void 0 : values.length) < 3)
        return 0;
    return (parseInt(values[0]) * 3600 + parseInt(values[1]) * 60 + parseInt(values[2]));
};
var getNumberWithZeroInStart = function (value) {
    return value < 10 ? "0".concat(value) : "".concat(value);
};
var getStringFromTime = function (value) {
    var hours = Math.floor(value / 3600);
    var minutes = Math.floor((value - hours * 3600) / 60);
    var seconds = value - hours * 3600 - minutes * 60;
    return "".concat(getNumberWithZeroInStart(hours), ":").concat(getNumberWithZeroInStart(minutes), ":").concat(getNumberWithZeroInStart(seconds));
};
export var PodcastEditBlock = function (props) {
    var t = useLocalization().t;
    var fileRef = props.fileRef, onAddImage = props.onAddImage, onClearPodcastFile = props.onClearPodcastFile, _a = props.podcastTimecodes, podcastTimecodes = _a === void 0 ? [] : _a, onSetPodcastTimeCodes = props.onSetPodcastTimeCodes, onSetPodcastTotalTime = props.onSetPodcastTotalTime, audioSrc = props.audioSrc, podcastName = props.podcastName, propIframeLink = props.iframeLink, onSetIframeLink = props.onSetIframeLink, _b = props.isNewPost, isNewPost = _b === void 0 ? true : _b;
    var audioRef = useRef(null);
    var _c = useState(0), totalDurationSec = _c[0], setTotalDurationSec = _c[1];
    var debounceTimer = useRef();
    var _d = useState(propIframeLink || ''), iframeLink = _d[0], setIframeLink = _d[1];
    var _e = useState(null), iframeLinkError = _e[0], setIframeLinkError = _e[1];
    var _f = useState(null), durationError = _f[0], setDurationError = _f[1];
    var _g = useState(null), formatError = _g[0], setFormatError = _g[1];
    useEffect(function () {
        setIframeLink(propIframeLink || '');
    }, [propIframeLink]);
    var onDeleteFile = function () {
        fileRef.current.value = '';
        onClearPodcastFile && onClearPodcastFile();
        onSetPodcastTimeCodes && onSetPodcastTimeCodes([]);
        setFormatError(null);
        setDurationError(null);
        if (iframeLink) {
            onSetIframeLink && onSetIframeLink('');
        }
    };
    var handleFileUpload = function (e) {
        var file = e.target.files[0];
        // Очищаем предыдущие ошибки
        setFormatError(null);
        setDurationError(null);
        if (iframeLink) {
            setIframeLink('');
            setIframeLinkError(null);
            onSetIframeLink && onSetIframeLink('');
            onSetPodcastTimeCodes && onSetPodcastTimeCodes([]);
        }
        // Проверяем формат файла
        if (file) {
            var allowedTypes = ['audio/wav', 'audio/mpeg', 'audio/mp3'];
            var fileExtension = file.name.toLowerCase().split('.').pop();
            var isAllowedExtension = ['wav', 'mp3'].includes(fileExtension);
            var isAllowedType = allowedTypes.includes(file.type);
            if (!isAllowedType && !isAllowedExtension) {
                setFormatError(t('editor.upload_file_here_without_sizes'));
                return;
            }
        }
        onAddImage(e, 'podcast');
    };
    var handleReplaceFile = function () {
        fileRef.current.click();
    };
    var onTimeCodeDelete = useCallback(function (index) {
        var timeCodes = __spreadArray([], podcastTimecodes, true);
        timeCodes.splice(index, 1);
        onSetPodcastTimeCodes(timeCodes);
    }, [podcastTimecodes, onSetPodcastTimeCodes]);
    var onTimeCodeAdd = useCallback(function () {
        if (!podcastName)
            return;
        var maxTime = 0;
        podcastTimecodes.forEach(function (i) {
            return getTimeNumber(i.time) > maxTime && (maxTime = getTimeNumber(i.time));
        });
        maxTime += 1;
        onSetPodcastTimeCodes(__spreadArray(__spreadArray([], podcastTimecodes, true), [
            { time: getStringFromTime(maxTime), link: '', name: '' }
        ], false));
    }, [podcastTimecodes, podcastName, onSetPodcastTimeCodes]);
    var onTimeCodeDragEnd = useCallback(function (result) {
        var source = result.source, destination = result.destination;
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId &&
            source.index === destination.index) {
            return;
        }
        var timeCodes = __spreadArray([], podcastTimecodes, true);
        timeCodes.splice(destination.index, 0, timeCodes.splice(source.index, 1)[0]);
        onSetPodcastTimeCodes(timeCodes);
    }, [podcastTimecodes, onSetPodcastTimeCodes]);
    var onTimeCodeChange = useCallback(function (index, value) {
        var timeCodes = __spreadArray([], podcastTimecodes, true);
        timeCodes[index] = __assign(__assign({}, timeCodes[index]), value);
        onSetPodcastTimeCodes(timeCodes);
    }, [podcastTimecodes, onSetPodcastTimeCodes]);
    var onChangeTime = useCallback(function (value, setValue) {
        var parts = value.split(':');
        if ((parts === null || parts === void 0 ? void 0 : parts.length) < 3) {
            setValue('00:00:00');
            return;
        }
        // normalize parts to numbers and clamp HMS ranges
        var h = Math.min(23, Math.max(0, parseInt(parts[0] || '0', 10)));
        var m = Math.min(59, Math.max(0, parseInt(parts[1] || '0', 10)));
        var s = Math.min(59, Math.max(0, parseInt(parts[2] || '0', 10)));
        // clamp to audio duration if known
        if (totalDurationSec && Number.isFinite(totalDurationSec) && totalDurationSec > 0) {
            var total = h * 3600 + m * 60 + s;
            var clamped = Math.min(total, Math.floor(totalDurationSec));
            h = Math.floor(clamped / 3600);
            m = Math.floor((clamped - h * 3600) / 60);
            s = clamped - h * 3600 - m * 60;
        }
        var hh = getNumberWithZeroInStart(h);
        var mm = getNumberWithZeroInStart(m);
        var ss = getNumberWithZeroInStart(s);
        setValue("".concat(hh, ":").concat(mm, ":").concat(ss));
    }, [totalDurationSec]);
    var resetTimer = function () {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
    };
    var handleIframeLinkChange = function (_a) {
        var value = _a.target.value;
        setIframeLink(value);
        if (iframeLinkError) {
            setIframeLinkError(null);
        }
        setFormatError(null);
        setDurationError(null);
        if (value && podcastName) {
            onSetPodcastTimeCodes && onSetPodcastTimeCodes([]);
            onDeleteFile();
        }
    };
    var validateIframeLink = useCallback(function (text) {
        var type = checkVideoType(text);
        var audioIframeCheck = text.match(/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/);
        if (['v', 'yt', 'nodata', 'vk'].includes(type) ||
            audioIframeCheck === null) {
            setIframeLinkError(t('editor.unknown_types.audio'));
            onSetIframeLink && onSetIframeLink('');
            return false;
        }
        else {
            setIframeLinkError(null);
            onSetIframeLink && onSetIframeLink(text);
            return true;
        }
    }, [t, onSetIframeLink]);
    useEffect(function () {
        if (iframeLink) {
            resetTimer();
            debounceTimer.current = setTimeout(function () {
                validateIframeLink(iframeLink);
            }, 500);
        }
        return function () {
            resetTimer();
        };
    }, [iframeLink, validateIframeLink]);
    useEffect(function () {
        if (!(audioRef === null || audioRef === void 0 ? void 0 : audioRef.current))
            return;
        var audio = audioRef.current;
        var onLoadedMetaData = function () {
            var duration = audio.duration;
            var maxDuration = 30 * 60;
            if (duration > maxDuration) {
                setDurationError(t('lms.podcast.duration_error'));
                onDeleteFile();
            }
            else {
                var sampleRate = 44100;
                var bitDepth = 16;
                var channels = 2;
                var calculatedSize = (sampleRate * bitDepth * channels * duration) / 8;
                var maxSize = 300 * 1024 * 1024;
                if (calculatedSize > maxSize) {
                    setDurationError(t('lms.podcast.size_error'));
                    onDeleteFile();
                }
                else {
                    setDurationError(null);
                    setTotalDurationSec(duration || 0);
                    onSetPodcastTotalTime(duration);
                }
            }
        };
        audio.addEventListener('loadedmetadata', onLoadedMetaData);
        return function () { return audio.removeEventListener('loadedmetadata', onLoadedMetaData); };
    }, [audioRef, onSetPodcastTotalTime, onDeleteFile, t]);
    return (React.createElement(PodcastEditBlockWrapper, null,
        React.createElement(PodcastContentWrapper, null,
            React.createElement(PodcastTitle, null, t('lms.podcast.load_podcast')),
            React.createElement(PodcastRightColumn, null,
                !podcastName && (React.createElement(IframeLinkInputWrapper, null,
                    React.createElement(IframeLinkInputContainer, null,
                        React.createElement(IframeLinkInput, { value: iframeLink, onChange: handleIframeLinkChange, placeholder: t('editor.placeholders.audio') })),
                    iframeLinkError && (React.createElement(IframeLinkError, null, iframeLinkError)))),
                iframeLink && !iframeLinkError && (React.createElement(PreviewAudioWrapper, null,
                    React.createElement(AudioPost, { post: { text: iframeLink } }))),
                podcastName && (React.createElement(FilePodcastContainer, null,
                    podcastName,
                    isNewPost && (React.createElement(React.Fragment, null,
                        React.createElement(DownloadIcon, { onClick: handleReplaceFile, style: { cursor: 'pointer' } }),
                        React.createElement("div", { className: 'closeIconWrapper', onClick: onDeleteFile, style: { height: 16 } },
                            React.createElement(CloseIcon, { style: { cursor: 'pointer', width: 16, height: 16 } })))))),
                React.createElement("audio", { id: 'audio', src: audioSrc, ref: audioRef }),
                durationError && React.createElement(IframeLinkError, null, durationError),
                React.createElement(InputPodcastContainer, { hidden: podcastName || iframeLink },
                    React.createElement("div", { className: 'placeholder' }, t('editor.upload_file_here_without_sizes')),
                    React.createElement("input", { type: 'file', accept: '.mp3, .wav', multiple: true, ref: fileRef, onChange: handleFileUpload })),
                podcastName && React.createElement(CopyLinkSwitcher, null),
                React.createElement(DragDropContext, { onDragEnd: onTimeCodeDragEnd }, (podcastTimecodes === null || podcastTimecodes === void 0 ? void 0 : podcastTimecodes.length) > 0 && (React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', gy: 8 },
                    React.createElement(GridTable, null,
                        React.createElement("div", null),
                        React.createElement(HeaderItem, null, t('lms.podcast.timecode_time')),
                        React.createElement(HeaderItem, null, t('lms.podcast.timecode_link')),
                        React.createElement(HeaderItem, null, t('lms.podcast.timecode_name'))),
                    React.createElement(TableWrapper, { direction: 'column', directionMobile: 'column', gy: 16, align: 'center', width: '100%' },
                        React.createElement(Droppable, { droppableId: 'droppable', type: 'PODCAST' }, function (provided, snapshot) { return (React.createElement(FlexBox, __assign({ ref: provided.innerRef }, provided.droppableProps, { direction: 'column', directionMobile: 'column', gy: 16 }),
                            podcastTimecodes.map(function (item, index) { return (React.createElement(Draggable, { key: index, index: index, draggableId: "item-".concat(index) }, function (provided, snapshot) {
                                var _a;
                                if (provided.draggableProps.style &&
                                    'top' in provided.draggableProps.style &&
                                    'left' in provided.draggableProps.style) {
                                    provided.draggableProps.style.top =
                                        index * 64 + 'px';
                                    provided.draggableProps.style.position =
                                        'absolute';
                                }
                                return (React.createElement(GridTableDragList, __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps),
                                    React.createElement(DragTableIcon, null),
                                    React.createElement(TimeCodeTimeInput, { item: item, index: index, onChangeTime: onChangeTime, onTimeCodeChange: onTimeCodeChange, maxTime: totalDurationSec > 0 ? getStringFromTime(Math.floor(totalDurationSec)) : undefined }),
                                    React.createElement(LinkTimeCodeInputWrapper, null,
                                        React.createElement(WhiteFieldItem, { type: 'text', value: item.link, placeholder: t('lms.podcast.paste_link_placeholder'), onChange: function (e) {
                                                return onTimeCodeChange(index, {
                                                    link: e.target.value
                                                });
                                            } }),
                                        ((_a = item.link) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(CloseIcon, { onClick: function () {
                                                return onTimeCodeChange(index, { link: '' });
                                            } }))),
                                    React.createElement(WhiteFieldItem, { type: 'text', value: item.name, placeholder: t('lms.podcast.name_placeholder'), onChange: function (e) {
                                            return onTimeCodeChange(index, {
                                                name: e.target.value
                                            });
                                        } }),
                                    React.createElement(FlexBox, { onClick: function () { return onTimeCodeDelete(index); } },
                                        React.createElement(DeleteTableIcon, null))));
                            })); }),
                            provided.placeholder)); }))))),
                podcastName && (React.createElement(PodcastAddButton, { disabled: !podcastName, onClick: onTimeCodeAdd }, (podcastTimecodes === null || podcastTimecodes === void 0 ? void 0 : podcastTimecodes.length) > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(PlusIcon, null),
                    t('lms.podcast.add_more'))) : (React.createElement(React.Fragment, null, t('lms.podcast.add_timecodes'))))),
                formatError && (React.createElement(IframeLinkError, { style: { textAlign: 'center' } }, formatError))))));
};
//# sourceMappingURL=PodcastEditBlock.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FilePodcastContainer, GridTable, GridTableDragList, HeaderItem, InputPodcastContainer, LinkTimeCodeInputWrapper, PodcastAddButton, PodcastEditBlockWrapper, PodcastContentWrapper, PodcastTitle, PodcastRightColumn, TableWrapper, WhiteFieldItem, IframeLinkInputWrapper, IframeLinkInputContainer, IframeLinkInput, IframeLinkError, PreviewAudioWrapper } from './styles';
import useLocalization from '../../../../../hooks/useLocalization';
import PlusIcon from '../../../../icons/PlusIcon';
import { DownloadIcon } from './components/DownloadIcon';
import CloseIcon from '../../../../icons/CloseIcon';
import { FlexBox } from '@brg/ui';
import { DragTableIcon } from './icons/DragTableIcon';
import { DeleteTableIcon } from './icons/DeleteTableIcon';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { TimeCodeTimeInput } from './components/TimeCodeTimeInput';
import { CopyLinkSwitcher } from './components/CopyLinkSwitcher';
import checkVideoType from '../../../../../utilites/checkVideoType';
import AudioPost from '../../postblocks/audioblock';
var getTimeNumber = function (value) {
    var values = value.split(':');
    if ((values === null || values === void 0 ? void 0 : values.length) < 3)
        return 0;
    return (parseInt(values[0]) * 3600 + parseInt(values[1]) * 60 + parseInt(values[2]));
};
var getNumberWithZeroInStart = function (value) {
    return value < 10 ? "0".concat(value) : "".concat(value);
};
var getStringFromTime = function (value) {
    var hours = Math.floor(value / 3600);
    var minutes = Math.floor((value - hours * 3600) / 60);
    var seconds = value - hours * 3600 - minutes * 60;
    return "".concat(getNumberWithZeroInStart(hours), ":").concat(getNumberWithZeroInStart(minutes), ":").concat(getNumberWithZeroInStart(seconds));
};
export var PodcastEditBlock = function (props) {
    var t = useLocalization().t;
    var fileRef = props.fileRef, onAddImage = props.onAddImage, onClearPodcastFile = props.onClearPodcastFile, _a = props.podcastTimecodes, podcastTimecodes = _a === void 0 ? [] : _a, onSetPodcastTimeCodes = props.onSetPodcastTimeCodes, onSetPodcastTotalTime = props.onSetPodcastTotalTime, audioSrc = props.audioSrc, podcastName = props.podcastName, propIframeLink = props.iframeLink, onSetIframeLink = props.onSetIframeLink, _b = props.isNewPost, isNewPost = _b === void 0 ? true : _b;
    var audioRef = useRef(null);
    var _c = useState(0), totalDurationSec = _c[0], setTotalDurationSec = _c[1];
    var debounceTimer = useRef();
    var _d = useState(propIframeLink || ''), iframeLink = _d[0], setIframeLink = _d[1];
    var _e = useState(null), iframeLinkError = _e[0], setIframeLinkError = _e[1];
    var _f = useState(null), durationError = _f[0], setDurationError = _f[1];
    var _g = useState(null), formatError = _g[0], setFormatError = _g[1];
    useEffect(function () {
        setIframeLink(propIframeLink || '');
    }, [propIframeLink]);
    var onDeleteFile = function () {
        fileRef.current.value = '';
        onClearPodcastFile && onClearPodcastFile();
        onSetPodcastTimeCodes && onSetPodcastTimeCodes([]);
        setFormatError(null);
        setDurationError(null);
        if (iframeLink) {
            onSetIframeLink && onSetIframeLink('');
        }
    };
    var handleFileUpload = function (e) {
        var file = e.target.files[0];
        // Очищаем предыдущие ошибки
        setFormatError(null);
        setDurationError(null);
        if (iframeLink) {
            setIframeLink('');
            setIframeLinkError(null);
            onSetIframeLink && onSetIframeLink('');
            onSetPodcastTimeCodes && onSetPodcastTimeCodes([]);
        }
        // Проверяем формат файла
        if (file) {
            var allowedTypes = ['audio/wav', 'audio/mpeg', 'audio/mp3'];
            var fileExtension = file.name.toLowerCase().split('.').pop();
            var isAllowedExtension = ['wav', 'mp3'].includes(fileExtension);
            var isAllowedType = allowedTypes.includes(file.type);
            if (!isAllowedType && !isAllowedExtension) {
                setFormatError(t('editor.upload_file_here_without_sizes'));
                return;
            }
        }
        onAddImage(e, 'podcast');
    };
    var handleReplaceFile = function () {
        fileRef.current.click();
    };
    var onTimeCodeDelete = useCallback(function (index) {
        var timeCodes = __spreadArray([], podcastTimecodes, true);
        timeCodes.splice(index, 1);
        onSetPodcastTimeCodes(timeCodes);
    }, [podcastTimecodes, onSetPodcastTimeCodes]);
    var onTimeCodeAdd = useCallback(function () {
        if (!podcastName)
            return;
        var maxTime = 0;
        podcastTimecodes.forEach(function (i) {
            return getTimeNumber(i.time) > maxTime && (maxTime = getTimeNumber(i.time));
        });
        maxTime += 1;
        onSetPodcastTimeCodes(__spreadArray(__spreadArray([], podcastTimecodes, true), [
            { time: getStringFromTime(maxTime), link: '', name: '' }
        ], false));
    }, [podcastTimecodes, podcastName, onSetPodcastTimeCodes]);
    var onTimeCodeDragEnd = useCallback(function (result) {
        var source = result.source, destination = result.destination;
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId &&
            source.index === destination.index) {
            return;
        }
        var timeCodes = __spreadArray([], podcastTimecodes, true);
        timeCodes.splice(destination.index, 0, timeCodes.splice(source.index, 1)[0]);
        onSetPodcastTimeCodes(timeCodes);
    }, [podcastTimecodes, onSetPodcastTimeCodes]);
    var onTimeCodeChange = useCallback(function (index, value) {
        var timeCodes = __spreadArray([], podcastTimecodes, true);
        timeCodes[index] = __assign(__assign({}, timeCodes[index]), value);
        onSetPodcastTimeCodes(timeCodes);
    }, [podcastTimecodes, onSetPodcastTimeCodes]);
    var onChangeTime = useCallback(function (value, setValue) {
        var parts = value.split(':');
        if ((parts === null || parts === void 0 ? void 0 : parts.length) < 3) {
            setValue('00:00:00');
            return;
        }
        // normalize parts to numbers and clamp HMS ranges
        var h = Math.min(23, Math.max(0, parseInt(parts[0] || '0', 10)));
        var m = Math.min(59, Math.max(0, parseInt(parts[1] || '0', 10)));
        var s = Math.min(59, Math.max(0, parseInt(parts[2] || '0', 10)));
        // clamp to audio duration if known
        if (totalDurationSec && Number.isFinite(totalDurationSec) && totalDurationSec > 0) {
            var total = h * 3600 + m * 60 + s;
            var clamped = Math.min(total, Math.floor(totalDurationSec));
            h = Math.floor(clamped / 3600);
            m = Math.floor((clamped - h * 3600) / 60);
            s = clamped - h * 3600 - m * 60;
        }
        var hh = getNumberWithZeroInStart(h);
        var mm = getNumberWithZeroInStart(m);
        var ss = getNumberWithZeroInStart(s);
        setValue("".concat(hh, ":").concat(mm, ":").concat(ss));
    }, [totalDurationSec]);
    var resetTimer = function () {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
            debounceTimer.current = null;
        }
    };
    var handleIframeLinkChange = function (_a) {
        var value = _a.target.value;
        setIframeLink(value);
        if (iframeLinkError) {
            setIframeLinkError(null);
        }
        setFormatError(null);
        setDurationError(null);
        if (value && podcastName) {
            onSetPodcastTimeCodes && onSetPodcastTimeCodes([]);
            onDeleteFile();
        }
    };
    var validateIframeLink = useCallback(function (text) {
        var type = checkVideoType(text);
        var audioIframeCheck = text.match(/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/);
        if (['v', 'yt', 'nodata', 'vk'].includes(type) ||
            audioIframeCheck === null) {
            setIframeLinkError(t('editor.unknown_types.audio'));
            onSetIframeLink && onSetIframeLink('');
            return false;
        }
        else {
            setIframeLinkError(null);
            onSetIframeLink && onSetIframeLink(text);
            return true;
        }
    }, [t, onSetIframeLink]);
    useEffect(function () {
        if (iframeLink) {
            resetTimer();
            debounceTimer.current = setTimeout(function () {
                validateIframeLink(iframeLink);
            }, 500);
        }
        return function () {
            resetTimer();
        };
    }, [iframeLink, validateIframeLink]);
    useEffect(function () {
        if (!(audioRef === null || audioRef === void 0 ? void 0 : audioRef.current))
            return;
        var audio = audioRef.current;
        var onLoadedMetaData = function () {
            var duration = audio.duration;
            var maxDuration = 30 * 60;
            if (duration > maxDuration) {
                setDurationError(t('lms.podcast.duration_error'));
                onDeleteFile();
            }
            else {
                var sampleRate = 44100;
                var bitDepth = 16;
                var channels = 2;
                var calculatedSize = (sampleRate * bitDepth * channels * duration) / 8;
                var maxSize = 300 * 1024 * 1024;
                if (calculatedSize > maxSize) {
                    setDurationError(t('lms.podcast.size_error'));
                    onDeleteFile();
                }
                else {
                    setDurationError(null);
                    setTotalDurationSec(duration || 0);
                    onSetPodcastTotalTime(duration);
                }
            }
        };
        audio.addEventListener('loadedmetadata', onLoadedMetaData);
        return function () { return audio.removeEventListener('loadedmetadata', onLoadedMetaData); };
    }, [audioRef, onSetPodcastTotalTime, onDeleteFile, t]);
    return (React.createElement(PodcastEditBlockWrapper, null,
        React.createElement(PodcastContentWrapper, null,
            React.createElement(PodcastTitle, null, t('lms.podcast.load_podcast')),
            React.createElement(PodcastRightColumn, null,
                !podcastName && (React.createElement(IframeLinkInputWrapper, null,
                    React.createElement(IframeLinkInputContainer, null,
                        React.createElement(IframeLinkInput, { value: iframeLink, onChange: handleIframeLinkChange, placeholder: t('editor.placeholders.audio') })),
                    iframeLinkError && (React.createElement(IframeLinkError, null, iframeLinkError)))),
                iframeLink && !iframeLinkError && (React.createElement(PreviewAudioWrapper, null,
                    React.createElement(AudioPost, { post: { text: iframeLink } }))),
                podcastName && (React.createElement(FilePodcastContainer, null,
                    podcastName,
                    isNewPost && (React.createElement(React.Fragment, null,
                        React.createElement(DownloadIcon, { onClick: handleReplaceFile, style: { cursor: 'pointer' } }),
                        React.createElement("div", { className: 'closeIconWrapper', onClick: onDeleteFile, style: { height: 16 } },
                            React.createElement(CloseIcon, { style: { cursor: 'pointer', width: 16, height: 16 } })))))),
                React.createElement("audio", { id: 'audio', src: audioSrc, ref: audioRef }),
                durationError && React.createElement(IframeLinkError, null, durationError),
                React.createElement(InputPodcastContainer, { hidden: podcastName || iframeLink },
                    React.createElement("div", { className: 'placeholder' }, t('editor.upload_file_here_without_sizes')),
                    React.createElement("input", { type: 'file', accept: '.mp3, .wav', multiple: true, ref: fileRef, onChange: handleFileUpload })),
                podcastName && React.createElement(CopyLinkSwitcher, null),
                React.createElement(DragDropContext, { onDragEnd: onTimeCodeDragEnd }, (podcastTimecodes === null || podcastTimecodes === void 0 ? void 0 : podcastTimecodes.length) > 0 && (React.createElement(FlexBox, { direction: 'column', directionMobile: 'column', gy: 8 },
                    React.createElement(GridTable, null,
                        React.createElement("div", null),
                        React.createElement(HeaderItem, null, t('lms.podcast.timecode_time')),
                        React.createElement(HeaderItem, null, t('lms.podcast.timecode_link')),
                        React.createElement(HeaderItem, null, t('lms.podcast.timecode_name'))),
                    React.createElement(TableWrapper, { direction: 'column', directionMobile: 'column', gy: 16, align: 'center', width: '100%' },
                        React.createElement(Droppable, { droppableId: 'droppable', type: 'PODCAST' }, function (provided, snapshot) { return (React.createElement(FlexBox, __assign({ ref: provided.innerRef }, provided.droppableProps, { direction: 'column', directionMobile: 'column', gy: 16 }),
                            podcastTimecodes.map(function (item, index) { return (React.createElement(Draggable, { key: index, index: index, draggableId: "item-".concat(index) }, function (provided, snapshot) {
                                var _a;
                                if (provided.draggableProps.style &&
                                    'top' in provided.draggableProps.style &&
                                    'left' in provided.draggableProps.style) {
                                    provided.draggableProps.style.top =
                                        index * 64 + 'px';
                                    provided.draggableProps.style.position =
                                        'absolute';
                                }
                                return (React.createElement(GridTableDragList, __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps),
                                    React.createElement(DragTableIcon, null),
                                    React.createElement(TimeCodeTimeInput, { item: item, index: index, onChangeTime: onChangeTime, onTimeCodeChange: onTimeCodeChange, maxTime: totalDurationSec > 0 ? getStringFromTime(Math.floor(totalDurationSec)) : undefined }),
                                    React.createElement(LinkTimeCodeInputWrapper, null,
                                        React.createElement(WhiteFieldItem, { type: 'text', value: item.link, placeholder: t('lms.podcast.paste_link_placeholder'), onChange: function (e) {
                                                return onTimeCodeChange(index, {
                                                    link: e.target.value
                                                });
                                            } }),
                                        ((_a = item.link) === null || _a === void 0 ? void 0 : _a.length) > 0 && (React.createElement(CloseIcon, { onClick: function () {
                                                return onTimeCodeChange(index, { link: '' });
                                            } }))),
                                    React.createElement(WhiteFieldItem, { type: 'text', value: item.name, placeholder: t('lms.podcast.name_placeholder'), onChange: function (e) {
                                            return onTimeCodeChange(index, {
                                                name: e.target.value
                                            });
                                        } }),
                                    React.createElement(FlexBox, { onClick: function () { return onTimeCodeDelete(index); } },
                                        React.createElement(DeleteTableIcon, null))));
                            })); }),
                            provided.placeholder)); }))))),
                podcastName && (React.createElement(PodcastAddButton, { disabled: !podcastName, onClick: onTimeCodeAdd }, (podcastTimecodes === null || podcastTimecodes === void 0 ? void 0 : podcastTimecodes.length) > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement(PlusIcon, null),
                    t('lms.podcast.add_more'))) : (React.createElement(React.Fragment, null, t('lms.podcast.add_timecodes'))))),
                formatError && (React.createElement(IframeLinkError, { style: { textAlign: 'center' } }, formatError))))));
};
//# sourceMappingURL=PodcastEditBlock.js.map